import {forwardRef} from 'react';

import {centerCircleStyles, indicatorStyles, inputStyles, rootStyles} from './Radio.css';
/**
 * Radio inputs allow the user to select a single option from a set.
 *
 * The Radio component renders a styled `<span>` element with a radio `<input>`
 * as one of its children, for styling purposes.
 *
 * All HTML attributes are supported, and forwarded to the corresponding `input`
 * element. The className prop, however, is placed on the root node, to aid in
 * applying custom styles to any of the components children, via child
 * selectors.
 *
 * `ref`s are forwarded to the `input` element.
 */
export const Radio = forwardRef<HTMLInputElement, React.HTMLProps<HTMLInputElement>>(
  ({className, disabled = false, checked, ...otherProps}, ref) => {
    return (
      <span className={`${rootStyles({disabled, checked})} ${className}`}>
        <input
          className={inputStyles}
          ref={ref}
          type="radio"
          {...otherProps}
          disabled={disabled}
          checked={checked}
        />
        <span className={indicatorStyles({disabled})}></span>
        <span className={centerCircleStyles({disabled, checked})} />
      </span>
    );
  },
);
